import { HoveredPointTooltip } from './HoveredPointTooltip/HoveredPointTooltip.js';
import { TopListTooltip } from './TopListTooltip.js';
import { useBarData } from '../../hooks/useBarData.js';
import type { BarSeriesWithDatapoints } from '../../types/xy-chart-internals.js';
import type { BarDatapoint } from '../../types/xy-chart.js';

export function BarSeriesTooltip({
  datapoint,
  series,
}: Readonly<{
  datapoint: BarDatapoint;
  series: BarSeriesWithDatapoints;
}>) {
  const { seriesToMetadata } = useBarData();

  if (series.labelAccessor) {
    return (
      <TopListTooltip
        datapoint={datapoint}
        series={series}
        seriesToMetadata={seriesToMetadata}
      />
    );
  }

  return (
    <HoveredPointTooltip
      datapoint={datapoint}
      series={series}
      seriesToMetadata={seriesToMetadata}
    />
  );
}
